module.exports = {
  ...require("./MESURE_PROTECTION"),
  ...require("./USER_DIRECTION"),
};
